import { CheckResult } from "./checkresult";
import { ResultLevel } from "./checkresultdata";

export class CheckResultListItem {
	constructor(text: string = "Validierungsfehler", resultLevel: number = ResultLevel.Warning, expanded: boolean = false, items: CheckResult[] = []) {
		this.text = text;
		this.resultLevel = resultLevel;
		this.items = items;
		this.expanded = expanded;
	}

	public text: string;
	public resultLevel: number;
	public items: CheckResult[];
	public expanded: boolean;
}